import LazyLoad from "vanilla-lazyload";

let callback_loaded = function(element) {
  // element.parentNode.classList.add('in-view')
  let canvas = element.parentNode.querySelector('canvas');
  // console.log("👍 LOADED", element);
  if (canvas) {
    canvas.classList.remove('blurred');
  }
};

const lazyLoadInstance = new LazyLoad({
    elements_selector: "[lazy]",
    callback_loaded: callback_loaded,
    threshold: 600
});

export {lazyLoadInstance};